import {Pushwoosh} from 'web-push-notifications';
const pwInstance = new Pushwoosh();
 
export default {
   
  init(root){

    return new Promise((resolve, reject) =>{

      try{

        console.log('PushWoosh Provider Loaded...');

        pwInstance.push(['init', {
          logLevel: 'info', // or error
          applicationCode: '09101-EB47A',
          //safariWebsitePushID: 'web.com.example.domain',
          defaultNotificationTitle: "Notifica da Maia",
          defaultNotificationImage: "https:\/\/cp.pushwoosh.com\/icons\/0\/9\/09101-EB47A.png",
          autoSubscribe: true,
        }]);  

        pwInstance.push(function(api) {
          console.log('Pushwoosh ready');
        });

        pwInstance.push(['onHideNotificationPermissionDialog', function(api, permission) {                  
          root.$emit("deviceRegistrationStatus",permission);
        }]);

        this.isSubscribed().then((res)=>{
            resolve(res)        
        })
        

      }catch(err){
        console.log(err)
        resolve(false)
      } 

    })

  },

  isSubscribed(){

    return new Promise((resolve, reject) =>{    
      pwInstance.isSubscribed().then(function(isSubscribed) {        
        resolve(isSubscribed)
      });
    })
  }
} 

